import React, { useState, useEffect } from 'react';
import apiService from '../../services/api';

const PointsLogs = () => {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const response = await apiService.getPointsLogs();
      setLogs(response.data);
    } catch (err) {
      setError('获取积分操作日志失败');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 根据操作类型返回不同的标签样式
  const getActionBadge = (action) => {
    switch (action) {
      case 'adjust_points':
        return <span className="badge bg-primary">积分调整</span>;
      case 'reset_all_points':
        return <span className="badge bg-danger">全员重置</span>;
      default:
        return <span className="badge bg-secondary">{action}</span>;
    }
  };

  // 格式化积分显示
  const formatPoints = (points) => {
    if (points === null) return '-';
    return points >= 0 ? `+${points}` : points;
  };

  // 搜索过滤
  const filteredLogs = logs.filter(log => {
    const kw = search.trim().toLowerCase();
    if (!kw) return true;
    return (
      (log.admin_nickname && log.admin_nickname.toLowerCase().includes(kw)) ||
      (log.admin_username && log.admin_username.toLowerCase().includes(kw)) ||
      (log.user_nickname && log.user_nickname.toLowerCase().includes(kw)) ||
      (log.user_username && log.user_username.toLowerCase().includes(kw)) ||
      (log.reason && log.reason.toLowerCase().includes(kw)) ||
      (log.action && log.action.toLowerCase().includes(kw))
    );
  });

  if (loading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">加载中...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="card mb-4">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h4 className="mb-0">积分操作日志</h4>
          <input
            type="text"
            className="form-control form-control-sm ms-2"
            style={{ maxWidth: 220 }}
            placeholder="关键字搜索..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {filteredLogs.length === 0 ? (
            <div className="alert alert-info">暂无匹配记录</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>操作类型</th>
                    <th>管理员</th>
                    <th>目标用户</th>
                    <th>积分变化</th>
                    <th>原因</th>
                    <th>操作时间</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredLogs.map(log => (
                    <tr key={log.id}>
                      <td>{log.id}</td>
                      <td>{getActionBadge(log.action)}</td>
                      <td>{log.admin_nickname || log.admin_username}</td>
                      <td>
                        {log.user_id ? (
                          log.user_nickname || log.user_username
                        ) : (
                          <span className="text-muted">全部用户</span>
                        )}
                      </td>
                      <td>
                        {log.points !== null ? (
                          <span className={`badge ${log.points >= 0 ? 'bg-success' : 'bg-danger'}`}>
                            {formatPoints(log.points)}
                          </span>
                        ) : (
                          <span className="badge bg-secondary">重置</span>
                        )}
                      </td>
                      <td>{log.reason}</td>
                      <td>{new Date(log.timestamp).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PointsLogs;
